export const getApp = ({app}) => app;
